import React from 'react';
import { useNavigate } from 'react-router-dom';

const DealerComingSoon: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#fdfaf5] flex flex-col items-center justify-center px-6 py-10 text-center select-none">
      {/* Logo */}
      <img
        src="/SCI Paints Bandhu Logo Final.png"
        alt="SCI Paints Bandhu"
        className="w-56 sm:w-72 md:w-80 h-auto mb-8"
      />

      {/* Top faint text */}
      <div className="text-2xl sm:text-4xl font-extrabold tracking-[0.15em] text-gray-300 mb-2">
        COMING SOON
      </div>

      {/* Middle gradient, bold and prominent */}
      <h1
        className="text-4xl sm:text-6xl font-black tracking-[0.15em] mb-2 bg-gradient-to-r from-[#5a2d82] via-[#9b2c7f] to-[#ee4238] text-transparent bg-clip-text"
      >
        COMING SOON
      </h1>

      {/* Bottom extra-faint echo */}
      <div className="text-2xl sm:text-4xl font-extrabold tracking-[0.15em] text-gray-200 mb-8">
        COMING SOON
      </div>

      {/* Caption */}
      <p className="text-gray-700 text-sm sm:text-base mb-10">
        Thanks for visiting and it will be available soon
      </p>

      <button
        onClick={() => navigate('/')}
        className="inline-block bg-[#ee4238] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:bg-[#d63a32] transition-colors"
      >
        BACK TO HOME
      </button>
    </div>
  );
};

export default DealerComingSoon;


